import { useContext } from 'react';
import { SeasonContext, type SeasonContextType } from '../contexts/seasonContextTypes';

export const useSeason = (): SeasonContextType => {
  const context = useContext(SeasonContext);
  if (context === undefined) {
    throw new Error('useSeason must be used within a SeasonProvider');
  }
  return context;
};

